import { createContext } from "react";

import { ClaimsScreenHelper } from "./ClaimsScreenHelper.ts";

export const ClaimsScreenContext = createContext<ClaimsScreenHelper>(
  {} as ClaimsScreenHelper
);
